import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { request } from "../../../../common/api";
import {
  GET_SENSOR_DATA,
  GET_SHIP_SELECT_OPTIONS,
  GET_SHIP_TYPE_SELECT_OPTIONS,
} from "../../../../common/query-keys";
import { InputSelect } from "../../../atoms/Inputs/InputSelect";
import { SearchContainer } from "../../../containers/SearchContainer";
import * as S from "./PageContent.style";
import { ReactComponent as IconArrow } from "../../../../styles/assets/svg/icon_title_arrow.svg";
import { Sensor } from "../../../../common/types/sensor";
import { showAlert } from "../../../containers/Alert";

interface PageContentProps {
  depth01Title: string;
  depth02Title?: string;
  depth03Title?: string;
  shipInfoSet?: boolean;
  searchBox?: React.ReactElement;
  children: React.ReactElement;
}

export const PageContent = ({
  depth01Title,
  depth02Title,
  depth03Title,
  shipInfoSet,
  searchBox,
  children,
}: PageContentProps) => {
  const [sensorData, setSensorData] = useState([]);
  const [isSsrShiptypeName, setIsSsrShiptypeName] = useState(false);
  const [isSsrShipName, setIsSsrShipName] = useState(false);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (name === "ssrShiptypeName") {
      setIsSsrShiptypeName(value);
    } else if (name === "ssrShipName") {
      setIsSsrShipName(value);
    }
  };

  // 센서 데이터 조회
  const { mutateAsync: getSensorData } = useMutation({
    mutationKey: [GET_SENSOR_DATA],
    mutationFn: async (searchCondition: any) => {
      return await request<Sensor[]>({
        method: "POST",
        url: "/sensor",
        data: searchCondition,
      });
    },
    onSuccess: (res: any) => {
      setSensorData(res);
    },
    onError: (e) => {
      showAlert(e.message);
    },
  });

  /** 조회 버튼 클릭시 */
  const onHandlerSearch = async (formSearch: any) => {
    await getSensorData({ ...formSearch });
  };

  return (
    <S.PageContent>
      <S.PageTitBox>
        {depth01Title}
        {depth02Title && (
          <>
            <IconArrow />
            {depth02Title}
          </>
        )}
        {depth03Title && (
          <>
            <IconArrow />
            {depth03Title}
          </>
        )}
      </S.PageTitBox>
      {shipInfoSet && (
        <SearchContainer onSearch={onHandlerSearch} components={[]} />
      )}

      <S.PageContentBox $shipInfoSet={searchBox ? true : false}>
        <div className="content-init">{children}</div>
      </S.PageContentBox>
    </S.PageContent>
  );
};

/** 수정 전 */
// import * as S from "./PageContent.style";
// import { ReactComponent as IconArrow } from "../../../../styles/assets/svg/icon_title_arrow.svg";

// interface PageContentProps {
//   depth01Title: string;
//   depth02Title?: string;
//   depth03Title?: string;
//   children: React.ReactElement;
// }

// export const PageContent = ({
//   depth01Title,
//   depth02Title,
//   depth03Title,
//   children,
// }: PageContentProps) => {
//   return (
//     <S.PageContent>
//       <S.PageTitBox>
//         {depth01Title}
//         {depth02Title && (
//           <>
//             <IconArrow />
//             {depth02Title}
//           </>
//         )}
//         {depth03Title && (
//           <>
//             <IconArrow />
//             {depth03Title}
//           </>
//         )}
//       </S.PageTitBox>

//       <S.PageContentBox>{children}</S.PageContentBox>
//     </S.PageContent>
//   );
// };
